module.exports = __webpack_public_path__ + "static/img/bg.c64c0dc9.png";